<!-- <p *ngIf="question.type!=='empty-box'" class="fw-bold">{{index}}. {{question.text}}</p>
<p *ngIf="question.type==='empty-box'" class="fw-bold">{{question.text}}</p> -->

<ng-container *ngIf="question.text; else defaultText">
    <!-- Text modificat dacă conține frazele căutate -->
    <div *ngIf="question.type!=='empty-box'" class="fw-bold" [ngStyle]="{'display': 'inline'}"
         [innerHTML]="applyHighlights(question.text)">
</div>

    
    <div *ngIf="question.type==='empty-box'" class="fw-bold" [ngStyle]="{'display': 'inline'}"
         [innerHTML]="applyHighlights(question.text)">
    </div>
    
</ng-container>
  
<!-- Text standard când nu există fraze de subliniat -->
<ng-template #defaultText>
    <p *ngIf="question.type!=='empty-box'" class="fw-bold" [ngStyle]="{'display': 'inline'}">
        {{index}}. {{question.text}}
    </p>
    <p *ngIf="question.type==='empty-box'" class="fw-bold" [ngStyle]="{'display': 'inline'}">
        {{question.text}}
    </p>
    

</ng-template>
<img *ngIf="question.image" [src]="question.image" class="question-image">
<p *ngIf="question.description"><em>{{question.description}}</em></p>


  
<!-- old version -->
<!-- <div *ngIf="question.type==='checkbox'">
    <div *ngFor="let response of question.renderResponse()" class="form-check" ngModelGroup="q_{{question.id}}">
        <input [type]="question.type" class="form-check-input" [name]="'q_'+question.id+'_'+response.id"
            [id]="'q_'+question.id+'_'+response.id" [checked]="response.selected" (change)="changedResponse(response)"
            [ngModel]="response.selected" />
        <label class="form-check-label" [for]="'q_'+question.id+'_'+response.id">
            {{response.text}}
        </label>

    </div>
</div> -->

<!-- new version with/without image -->
<div *ngIf="question.type==='checkbox'">
    <div *ngFor="let response of question.renderResponse(); index as i" class="form-check" style="padding: 0;">
        <div *ngIf="response.image && question.type_id_checkbox == 1 && question.has_logo == true"style="display: block;"  ngModelGroup="q_{{question.id}}">
            <div *ngIf="i == 0" style="width: 100%; margin-top: 30px; margin-bottom: 10px; ">

                <img  [src]="'./assets/images/brand_glo.png'" height="50px"style="margin-left: 35px;"/>
                <!-- <div style="border: 1px solid #CCC; width: 100%; height: 1px; opacity: 0.6;">

            </div> -->
            </div>
            <div *ngIf="i == 4" style="width: 100%; margin-top: 30px; margin-bottom: 10px;">
                <img [src]="'./assets/images/brand_iqs.png'" height="25px"style="margin-left: 35px;"/>
                <!-- <div style="border: 1px solid #CCC; width: 50%; height: 1px; opacity: 0.6;"> -->

                <!-- </div> -->
            </div>

            <div *ngIf="i == 8" style="width: 100%; margin-top: 30px; margin-bottom: 10px;">
                <img  [src]="'./assets/images/brand_lil.png'" height="60px"style="margin-left: 35px;"/>
                <!-- <div style="border: 1px solid #CCC; width: 100%; height: 1px; opacity: 0.6;">

                </div> -->
            </div>  

            
            <div *ngIf="i == 9" style="width: 100%; margin-top: 30px; margin-bottom: 10px;">
                <img  [src]="'./assets/images/brand_ploom.png'" height="60px"style="margin-left: 35px;"/>
                <!-- <div style="border: 1px solid #CCC; width: 100%; height: 1px; opacity: 0.6;">
                </div> -->
            
            </div>  
            <div class="form-check items-center img-checkbox-2-mobile">
                <div class="img-box"> <img *ngIf="response.image" [src]="response.image" height="50px"/></div>
                <input type="checkbox" class="form-check-input" [name]="'q_'+question.id+'_'+response.id"
                    [id]="'q_'+question.id+'_'+response.id" [checked]="response.selected" (change)="changedResponse(response)"
                    [ngModel]="response.selected" />
                <label class="form-check-label" [for]="'q_'+question.id+'_'+response.id">
                    {{response.text}}
                </label>
            </div>
        </div>

        <div *ngIf="response.image && question.type_id_checkbox == 1 && question.has_logo == false"style="display: block;"  ngModelGroup="q_{{question.id}}">
            <div class="form-check items-center img-checkbox-2-mobile">
                <div class="img-box"> <img *ngIf="response.image" [src]="response.image" height="50px"/></div>
                <input type="checkbox" class="form-check-input" [name]="'q_'+question.id+'_'+response.id"
                    [id]="'q_'+question.id+'_'+response.id" [checked]="response.selected" (change)="changedResponse(response)"
                    [ngModel]="response.selected" />
                <label class="form-check-label" [for]="'q_'+question.id+'_'+response.id">
                    {{response.text}}
                </label>
            </div>
        </div>

        
        <div  *ngIf="response.image && question.type_id_checkbox == 2" class="form-check items-center img-checkbox-2-mobile" ngModelGroup="q_{{question.id}}">
            <div class="img-box2"> <img *ngIf="response.image" [src]="response.image" height="50px"/></div>
            <input type="checkbox" class="form-check-input" [name]="'q_'+question.id+'_'+response.id"
                [id]="'q_'+question.id+'_'+response.id" [checked]="response.selected" (change)="changedResponse(response)"
                [ngModel]="response.selected" />
    
            <label class="form-check-label" [for]="'q_'+question.id+'_'+response.id">
                {{response.text}}
            </label>
               
        </div>
        
        <div *ngIf="!response.image" class="form-check " ngModelGroup="q_{{question.id}}">
            <input [type]="question.type" class="form-check-input" [name]="'q_'+question.id+'_'+response.id"
                [id]="'q_'+question.id+'_'+response.id" [checked]="response.selected" (change)="changedResponse(response)"
                [ngModel]="response.selected" />
            <label class="form-check-label" [for]="'q_'+question.id+'_'+response.id">
                {{response.text}}
            </label>
            
        </div>
    </div>
</div>


<div *ngIf="question.type==='checkbox-inline'">
    <div *ngFor="let response of question.renderResponse()" class="form-check-inline" ngModelGroup="q_{{question.id}}">
        <input type="checkbox" class="form-check-input" [name]="'q_'+question.id+'_'+response.id"
            [id]="'q_'+question.id+'_'+response.id" [checked]="response.selected" (change)="changedResponse(response)"
            [ngModel]="response.selected" />
        <label class="form-check-label" [for]="'q_'+question.id+'_'+response.id">
            {{response.text}}
        </label>

    </div>
</div>

<div *ngIf="question.type==='checkbox-free'">
    <div *ngFor="let response of question.renderResponse(); let i = index;" class="form-check">
        <input  type="checkbox" class="form-check-input" [name]="'q_'+question.id+'_'+response.id"
            [id]="'q_'+question.id+'_'+response.id" [checked]="response.selected" (change)="changedResponse(response)"
            [ngModel]="response.selected" />
        <label class="form-check-label" [for]="'q_'+question.id+'_'+response.id">
            {{response.text}}
        </label>
        <textarea placeholder="Inserează răspunsul tău aici"
        (blur)="lockQuestionText(response)" 
        *ngIf="i === question.renderResponse().length-1" 
        [disabled]="question.isDisabledText || false"
        [name]="'q_'+question.id+'_'+response.id+'_free'"

            class="form-control" rows="1" [disabled]="!response.selected" [(ngModel)]="response.freeMessage"></textarea>
          
    </div>
    
</div>


<div *ngIf="question.type === 'radio-free'">
    <div *ngFor="let response of question.renderResponse(); let i = index;" class="form-check" >
        <div>
            <input  [disabled]="question.isDisable"  type="radio" class="form-check-input" [name]="'q_' + question.id"
                [id]="'q_' + question.id + '_' + response.id" [checked]="response.selected" 
                (change)="changedResponse(response)" ngModelGroup="q_{{question.id}}" />
            <label class="form-check-label" [for]="'q_' + question.id + '_' + response.id">
                {{ response.text }}
            </label>
            <!-- Textarea pentru ultimul răspuns cu opțiunea de mesaj liber -->
            <textarea 
            placeholder="Inserează răspunsul tău aici"
            (blur)="lockQuestionText(response)" 
            *ngIf="i === question.renderResponse().length - 1" 
            [disabled]="question.isDisabledText || false"
            [name]="'q_' + question.id + '_' + response.id + '_free'"
            class="form-control" rows="1" [disabled]="!response.selected" 
            [(ngModel)]="response.freeMessage"></textarea>
        </div>
    </div>
    <!-- <div *ngIf="question.footer">
        <i style="font-size: 13px;">{{question.footer}}</i>
    </div> -->
</div>
<!-- <textarea 
            placeholder="Inserează răspunsul tău aici"
            (blur)="lockQuestionText(response)" 
            *ngIf="i === question.renderResponse().length - 1" 
            [disabled]="question.isDisabledText || false"
            [name]="'q_' + question.id + '_' + response.id + '_free'"
            class="form-control" rows="1" [disabled]="!response.selected" 
            [(ngModel)]="response.freeMessage"></textarea> -->

<div *ngIf="question.type==='radio'">
    <div *ngFor="let response of question.renderResponse()" class="form-check">
        <input [disabled]="question.isDisable" [type]="question.type" class="form-check-input" (change)="changedResponse(response)"
            [name]="'q_'+question.id" value="123" [id]="'q_'+question.id+'_'+response.id"
            [checked]="response.selected" />
        <label class="form-check-label" [for]="'q_'+question.id+'_'+response.id">
            {{response.text}}
        </label>
    </div>
</div>


<div *ngIf="question.type === 'radio-inline'" 
     [ngClass]="{'mobile-display': question.mobileDisplay, 'space-radio': true, 'space-radio-mobile': true}">

    <div *ngFor="let response of question.renderResponse()" class="form-check-radio">
        <div class="radio-inner">

            <label class="form-check-label" [for]="'q_'+question.id+'_'+response.id">
                {{response.text}}
            </label>
            <input  [disabled]="question.isDisable" (blur)="lockQuestion()" type="radio" class="form-check-input" (change)="changedResponse(response)" [name]="'q_'+question.id"
                value="123" [id]="'q_'+question.id+'_'+response.id" [checked]="response.selected" />
        </div>
    </div>
</div>


<!-- <div *ngIf="question.type==='radio-inline-img'" class="space-radio space-radio-mobile">
    <div *ngFor="let response of question.renderResponse()" class="form-check-radio">
        <div class="img-box"> <img *ngIf="response.image" [src]="response.image" height="50px"/></div>
        <div class="radio-inner">

            <label class="form-check-label" [for]="'q_'+question.id+'_'+response.id">
                {{response.text}}
            </label>
            <input  [disabled]="question.isDisable" (blur)="lockQuestion()" type="radio" class="form-check-input" (change)="changedResponse(response)" [name]="'q_'+question.id"
                value="123" [id]="'q_'+question.id+'_'+response.id" [checked]="response.selected" />
        </div>
    </div>
</div> -->



<div *ngIf="question.type==='order'">
    <div *ngFor="let response of question.renderResponse()" class="form-check">
        <div class="row">
            <label class="form-select-label col-9">
                {{response.text}}
            </label>
            <div class="col-3">
                <input type="number" class="form-control" [(ngModel)]="response.score" [min]="0"
                    [max]="question.renderResponse().length" [name]="'q_'+question.id+'_'+response.id">
            </div>
        </div>
    </div>
</div>


<div *ngIf="question.type==='star'">
    <div *ngFor="let response of question.renderResponse()" class="form-check">
        <div class="row">
            <label class="form-select-label col-xs-12 col-sm-12 col-md-9 col-lg-9">
                {{response.text}}
            </label>
            <div class="col-xs-12 col-sm-12 col-md-3 col-lg-3">
                <ngb-rating [(rate)]="response.score" [max]="5">
                    <ng-template let-fill="fill" let-index="index">
                        <span class="star" [class.filled]="fill === 100">&#9733;</span>
                    </ng-template>
                </ngb-rating>
            </div>
        </div>

    </div>
</div>

<div *ngIf="question.type==='free'">
    <div *ngFor="let response of question.renderResponse()" class="form-check">
        <textarea class="form-control" rows="3" [(ngModel)]="response.freeMessage"
            [name]="'q_'+question.id+'_'+response.id"></textarea>
    </div>
</div>

<div *ngIf="question.type==='free-number'">
    <div *ngFor="let response of question.renderResponse()" class="form-check">
        <input 
        placeholder="Inserează răspunsul tău aici"
        (blur)="lockQuestionText(response)" 
        class="form-control" type="number" [(ngModel)]="response.freeMessage"
        [disabled]="question.isDisabledText || false"
        [name]="'q_'+question.id+'_'+response.id" />
    </div>
</div>


<div *ngIf="question.type==='free-message'">
    <div *ngFor="let response of question.renderResponse()" class="form-check">
        <input 
        placeholder="Inserează răspunsul tău aici"
        (blur)="lockQuestionText(response)" 
        class="form-control" type="string" [(ngModel)]="response.freeMessage"
        [disabled]="question.isDisabledText || false"
        [name]="'q_'+question.id+'_'+response.id" />
    </div>
</div>




<div *ngIf="question.type==='free-number-warning'">
    <div *ngFor="let response of question.renderResponse()" class="form-check">
        <input 
        placeholder="Inserează răspunsul tău aici"
        (blur)="lockQuestionText(response)" 
        class="form-control" type="number" [(ngModel)]="response.freeMessage"
        [disabled]="question.isDisabledText || false"
            [name]="'q_'+question.id+'_'+response.id" />
        <!-- Afișează mesajul de avertizare dacă numărul este negativ sau în afara intervalului -->
        <div *ngIf="isNotInInterval(response.freeMessage, question?.warning?.min, question?.warning?.max)" class="alert alert-warning" style="font-size:10px; padding:5px 10px">
            Atenție: Introduceți un număr cuprins între {{question?.warning?.min}} și {{question?.warning?.max}}.
        </div>
    </div>
</div>


 <!-- <div *ngIf="question.type==='free-number-1-10'">
    <div *ngFor="let response of question.renderResponse()" class="form-check">
        <input class="form-control" type="number" [(ngModel)]="response.freeMessage"
            [name]="'q_'+question.id+'_'+response.id" />
        <div *ngIf="isNotInInterval1_10(response.freeMessage)" class="alert alert-warning" style="font-size:10px; padding:5px 10px">
            Atenție: Introduceți un număr cuprins între 1 și 10.
        </div>
    </div>
</div> -->


<div *ngIf="question.type === 'free-number-warning-reset'">
    <div *ngFor="let response of question.renderResponse()" class="form-check">
        <input placeholder="Inserează răspunsul tău aici"
        (blur)="lockQuestionText(response)" 
         class="form-control" type="number"
        [disabled]="question.isDisabledText || false"
            [(ngModel)]="response.freeMessage"
            [name]="'q_' + question.id + '_' + response.id"
            step="1"
            required
            (input)="onInputChange($event, response, question?.warning?.min, question?.warning?.max)" />

        <div *ngIf="showWarning" class="alert alert-warning" style="font-size:10px; padding:5px 10px">
            Atenție: Introduceți un număr cuprins între {{question?.warning?.min}} și {{question?.warning?.max}}.
        </div>
    </div>
</div>


<!-- <div *ngIf="question.type === 'free-number-1-5'">
    <div *ngFor="let response of question.renderResponse()" class="form-check">
        <input class="form-control" type="number"
            [(ngModel)]="response.freeMessage"
            [name]="'q_' + question.id + '_' + response.id"
            [attr.min]="minValue1_5"
            [attr.max]="maxValue1_5"
            step="1"
            required
            (input)="onInputChange1_5($event, response)" />

        <div *ngIf="showWarning1_5" class="alert alert-warning" style="font-size:10px; padding:5px 10px">
            Atenție: Introduceți un număr cuprins între {{ minValue1_5 }} și {{ maxValue1_5 }}.
        </div>
    </div>
</div>  -->



<div *ngIf="question.type==='free-number-label'">
    <div *ngFor="let response of question.renderResponse()" class="form-check">
        <div class="row">
            <label *ngIf="response.text" class="form-select-label col-9">
                {{response.text}} 
            </label>
            <div class="col-3">
                <input type="number" class="form-control" [(ngModel)]="response.score" [min]="0"
                    [name]="'q_'+question.id+'_'+response.id">
            </div>
        </div>
    </div>
</div>


<!-- <div *ngIf="question.type==='free-number-label-img'">
    <div *ngFor="let response of question.renderResponse()" class="form-check">
        <div class="row">
            <div class="col-9 d-flex align-items-center">
                <div class="img-box">
                    <img *ngIf="response.image" [src]="response.image" height="50px"/>
                </div>
                <label *ngIf="response.text" class="form-select-label">
                    {{response.text}} 
                </label>
            </div>
            <div class="col-3">
                <input type="number" class="form-control" [(ngModel)]="response.score" [min]="0" placeholder="0" 
                    [name]="'q_'+question.id+'_'+response.id">
                <div *ngIf="isInvalidNumber(response.score)" class="alert alert-warning" style="font-size: 10px; padding: 1px 1px;">
                    Atenție: Introduceți un număr cuprins între 1 și 10.
                </div>
            </div>
        </div>
    </div>
</div> -->






<div *ngIf="question.type==='dropdown'">
    <select #el class="form-select" (change)="updateDropdown(el, question)">
        <option value="null">Alege</option>
        <option *ngFor="let response of question.renderResponse()" [value]="response.text">
            {{response.text}}
        </option>
    </select>
</div>






<div *ngIf="question.footer">
    <i style="font-size: 13px; color: #969595;">{{question.footer}}</i>
</div>